module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av697-bd390d776132d0420a2b257262a82119.jpg";